import React from "react";
import { Route, Switch } from "react-router-dom";
import Layout from "./layouts/Layout";
import Publishers from "./routes/Publishers";
import Publisher from "./routes/Publisher";
import Login from "./routes/Login";

export default (
  <Layout>
    <Switch>
      <Route exact path={"/login"} component={Login} />
      <Route exact path={"/publishers/:publisherID"} component={Publisher} />
      <Route exact path={"/publishers"} component={Publishers} />
      <Route path={"*"} component={Publishers} />
    </Switch>
  </Layout>
);
